import React from 'react';
import { useParams } from 'react-router-dom';
import { Logs } from 'components/common/logs';
import { HasAccess } from 'components/common/accessControl';
import { PERMISSIONS } from 'constants/permissions';

export const CountryLogs = React.memo(() => {
  const { id } = useParams();
  return (
    <HasAccess role={PERMISSIONS.countries.logs.read}>
      <div className={'logs-layout-container'}>
        <Logs entityName={'COUNTRY'} id={id} />
      </div>
    </HasAccess>
  );
});
